export default "__VITE_ASSET__BysJiZ75__"